import React from "react";
import { Table, Badge } from "react-bootstrap";

const RESULT_VARIANT = { PASS: "success", FAIL: "danger", NOT_APPLICABLE: "secondary" };

// Phase 3C, §27/§30. `sections`: GET /api/form-submissions/:id/result/sections.
export default function FormSectionScoreBreakdown({ sections }) {
  if (!sections || !sections.length) {
    return <div className="text-muted small">No section-level scoring configured for this form.</div>;
  }

  return (
    <Table size="sm" responsive className="mb-0">
      <thead>
        <tr>
          <th>Section</th>
          <th>Obtained</th>
          <th>Maximum</th>
          <th>Percentage</th>
          <th>Weightage</th>
          <th>Result</th>
        </tr>
      </thead>
      <tbody>
        {sections.map((s) => (
          <tr key={s.id || s.form_section_id}>
            <td>{s.section_title}</td>
            <td>{s.obtained_score ?? "—"}</td>
            <td>{s.maximum_score ?? "—"}</td>
            <td>{s.percentage != null ? `${s.percentage}%` : "—"}</td>
            <td>{s.weightage != null ? `${s.weightage}%` : "—"}</td>
            <td>{s.result_code ? <Badge bg={RESULT_VARIANT[s.result_code] || "secondary"}>{s.result_code}</Badge> : "—"}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
